import React from "react";
import { Modal, Table, Form, ProgressBar, Button, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { XCircleFill } from "react-bootstrap-icons";
import Swal from "sweetalert2";
import { esalonariApi } from "../../../api/esalonariApi";

const ModalRealizari = ({
  show,
  onHide,
  partidaActiva,
  dateRealizari,
  setDateRealizari,
  realizareExcesiva,
  totalRealizatEfectiv,
  procentTotalRealizat,
  totalIntroducereNoua
}) => {

  const handleStergeReceptie = async (esalonareId, receptie) => {
    const confirmare = await Swal.fire({
      title: "Ștergi recepția?",
      text: `Vrei să elimini ${receptie.nrReceptie}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Da, șterge-o!",
      cancelButtonText: "Nu",
    });

    if (confirmare.isConfirmed) {
      try {
        await esalonariApi.deleteReceptie(esalonareId, receptie);

        setDateRealizari((prev) =>
          prev.map((rand) => {
            if (rand.id === esalonareId) {
              return {
                ...rand,
                istoricReceptii: rand.istoricReceptii.filter(
                  (r) => r.id !== receptie.id,
                ),
                volumRealizat:
                  (Number(rand.volumRealizat) || 0) -
                  ((Number(receptie.volum) || 0) +
                    (Number(receptie.volumPierderi) || 0)),
              };
            }

            return rand;
          }),
        );

        Swal.fire("Șters!", "Baza de date a fost actualizată.", "success");
      } catch (err) {
        Swal.fire(
          "Eroare",
          "Serverul nu a putut șterge: " + err.message,
          "error",
        );
      }
    }
  };

  const salveazaRealizarile = async () => {
    if (realizareExcesiva) return;
    try {
      await esalonariApi.saveRealizari({ dateEsalonare: dateRealizari, partidaId: partidaActiva.id });
      Swal.fire({ title: "Succes", text: "Recepțiile au fost înregistrate!", icon: "success", timer: 1500, showConfirmButton: false });
      onHide();
    } catch (err) {
      Swal.fire("Eroare", err.message, "error");
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton className={realizareExcesiva ? "bg-danger text-white" : "bg-success text-white"}>
        <Modal.Title>
          Jurnal Recepții: {partidaActiva?.fond}
          {realizareExcesiva && <small className="ms-3 fw-light">⚠️ VOLUM DEPĂȘIT!</small>}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6 className="fw-bold mb-3">Introducere recepție nouă</h6>
        <Table striped bordered hover responsive align="middle" size="sm">
          <thead className="table-light small text-center">
            <tr>
              <th>Lună</th>
              <th>Realizat Ant.</th>
              <th>Nr. Doc</th>
              <th>Volum (mc)</th>
              <th>Pierderi (mc)</th>
            </tr>
          </thead>
          <tbody>
            {dateRealizari.map((rand, index) => (
              <tr key={rand.id || index}>
                <td className="fw-bold">{rand.luna}</td>
                <td className="text-muted small">{(parseFloat(rand.volumRealizat) || 0).toFixed(2)}</td>
                <td>
                  <Form.Control
                    size="sm"
                    placeholder="Ex: Receptia 1"
                    value={rand.nrReceptieNou || ""}
                    onChange={(e) => {
                      const noi = [...dateRealizari];
                      noi[index].nrReceptieNou = e.target.value;
                      setDateRealizari(noi);
                    }}
                  />
                </td>
                <td>
                  <Form.Control
                    size="sm"
                    type="number"
                    placeholder="mc"
                    value={rand.inputNou === 0 ? "" : rand.inputNou}
                    isInvalid={realizareExcesiva}
                    onChange={(e) => {
                      const noi = [...dateRealizari];
                      noi[index].inputNou = e.target.value === "" ? 0 : parseFloat(e.target.value);
                      setDateRealizari(noi);
                    }}
                  />
                </td>
                <td>
                  <Form.Control
                    size="sm"
                    type="number"
                    placeholder="pierderi"
                    className="text-danger"
                    value={rand.inputPierderi === 0 ? "" : rand.inputPierderi}
                    isInvalid={realizareExcesiva}
                    onChange={(e) => {
                      const noi = [...dateRealizari];
                      noi[index].inputPierderi = e.target.value === "" ? 0 : parseFloat(e.target.value);
                      setDateRealizari(noi);
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="mt-4 mb-3 p-3 bg-white border rounded shadow-sm">
          <div className="d-flex justify-content-between mb-1 fw-bold">
            <span>Progres Exploatare (Inclusiv pierderi)</span>
            <span className={realizareExcesiva ? "text-danger" : "text-success"}>
              {totalRealizatEfectiv.toFixed(1)} / {partidaActiva?.volBrut} mc
            </span>
          </div>
          <ProgressBar
            now={procentTotalRealizat > 100 ? 100 : procentTotalRealizat}
            variant={realizareExcesiva ? "danger" : "success"}
            label={`${procentTotalRealizat.toFixed(1)}%`}
            striped
            animated={realizareExcesiva}
            style={{ height: "25px" }}
          />
          {realizareExcesiva && (
            <div className="text-danger small mt-1 fw-bold text-center">
              ❌ Nu puteți salva: Volumul introdus depășește volumul brut!
            </div>
          )}
        </div>

        <div className="mt-4">
          <h6 className="fw-bold text-muted border-bottom pb-2 mb-2 small">ISTORIC RECEPȚII</h6>
          <div style={{ maxHeight: "150px", overflowY: "auto" }} className="border rounded">
            <Table hover size="sm" className="mb-0 small">
              <thead className="table-light sticky-top">
                <tr>
                  <th>Document</th>
                  <th>Data</th>
                  <th className="text-end">Volum</th>
                  <th className="text-end">Pierderi</th>
                  <th>Acțiuni</th>
                </tr>
              </thead>
              <tbody>
                {dateRealizari.map((rand) =>
                  rand.istoricReceptii?.map((hist, i) => (
                    <tr key={`${rand.id}-${i}`}>
                      <td>{hist.nrReceptie}</td>
                      <td>{new Date(hist.dataRaportare).toLocaleDateString("ro-RO")}</td>
                      <td className="text-end fw-bold">{hist.volum} mc</td>
                      <td className="text-end text-danger">{hist.volumPierderi?.toFixed(2) || 0} mc</td>
                      <td className="text-center">
                        <Button variant="link" size="sm" className="text-danger p-0" onClick={() => handleStergeReceptie(rand.id, hist)}>
                          <XCircleFill />
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {Math.abs(totalRealizatEfectiv - (parseFloat(partidaActiva?.volBrut) || 0)) <= parseFloat(partidaActiva?.volBrut) * 0.05 &&
        partidaActiva?.stare !== "reprimit" ? (
          <Button
            variant="warning"
            className="me-auto"
            onClick={async () => {
              try {
                await esalonariApi.updateStarePartida(partidaActiva.id, "reprimit");
                Swal.fire("Succes", "Starea partizii a fost actualizată!", "success");
                onHide();
              } catch (err) {
                Swal.fire("Eroare", err.message, "error");
              }
            }}
          >
            Marchează ca Reprimit
          </Button>
        ) : (
          partidaActiva?.stare === "reprimit" && <Badge bg="secondary" className="me-auto">Reprimita</Badge>
        )}

        <Button variant="outline-secondary" onClick={onHide}>Anulează</Button>
        <OverlayTrigger
          placement="top"
          trigger={partidaActiva?.stare === "reprimit" ? ["hover", "focus"] : []}
          overlay={<Tooltip>Partida este deja reprimita.</Tooltip>}
        >
          <span className="d-inline-block">
            <Button
              variant={realizareExcesiva ? "danger" : "success"}
              onClick={salveazaRealizarile}
              disabled={realizareExcesiva || totalIntroducereNoua === 0 || partidaActiva?.stare === "reprimit"}
            >
              {realizareExcesiva ? "Depășire Volum" : "Confirmă recepția"}
            </Button>
          </span>
        </OverlayTrigger>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalRealizari;